import { JobProgress } from '@app/components/base/JobProgress';
import { EnrichedVideoEditorEditListItemDto } from '@app/modules/video-editions/types';
import { videoEditor } from '@mi-front/api-clients';
import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';
import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';

export interface EditCardRenderStatusProps {
  renderJob: EnrichedVideoEditorEditListItemDto['renderJob'];
}

/**
 * Shows render progress for an in-flight job, or a static “not generated” chip when there is no job.
 */
export function EditCardRenderStatus({ renderJob }: EditCardRenderStatusProps) {
  const { $t } = useIntl();

  if (renderJob) {
    return (
      <JobProgress
        job={renderJob as videoEditor.PublicJobWithResultDto}
        size="small"
        variant={'filled'}
        statusLabels={{
          COMPLETED: $t({
            id: 'videoEditions.status.generated',
            defaultMessage: 'Listo para publicar',
          }),
        }}
        statusColors={{
          COMPLETED: 'warning',
        }}
        statusIcons={{
          COMPLETED: <PublishOutlinedIcon fontSize="small" />,
        }}
      />
    );
  }

  return (
    <Chip
      label={$t({
        id: 'videoEditions.status.notGenerated',
        defaultMessage: 'Sin generar',
      })}
      variant="outlined"
      size="small"
      sx={{ backgroundColor: 'background.paper' }}
    />
  );
}
